/** Domínio público (canonical, OG url). Ajuste se usar outro host. */
export const SITE_ORIGIN = "https://www.whatsmeapp.com";

/**
 * Google Analytics 4 Measurement ID (ex.: "G-XXXXXXXXXX").
 * Mantenha em sincronia com o snippet do GA em `src/index.html`.
 */
export const GA4_MEASUREMENT_ID = "G-D7HP9N39TN";
